import { FirebasePerformanceService } from './FirebasePerformance';

export const performanceServiceFactory = () => new FirebasePerformanceService();
